import { createContext, useContext } from 'react'

const MenuContext = createContext()
export default MenuContext

export function useMenuContext () {
  return useContext(MenuContext)
}